// extracted by mini-css-extract-plugin
export var button = "_n7-2";
export var card = "_n7-0";
export var closeButtonContainer = "_n7-3";
export var iconContainer = "_n7-1";